export default __webpack_public_path__ + "static/media/roadmapbg.fedb56ee.png";